const ROOT = 'inventory-sync' as const;

export const inventorySyncQueryKeys = {
  connections: () => [ROOT, 'connections'] as const,

  skuSyncState: (sku: string) => [ROOT, 'sku-sync-state', sku] as const,

  skuSyncHistory: (sku: string, connectionId: string, page: number, limit: number) =>
    [ROOT, 'sku-sync-history', sku, connectionId, page, limit] as const,
} as const;
